import { css } from "styled-components";
import { getPrimaryColor100, getPrimaryColor40 } from "oolib/dist/utilsOolib";
import { globalHoverOnWhiteBG } from "oolib/dist/globalStyles/globalVariables";
import { boxShadow1, transition } from "oolib/dist/themes/mixins";
import { colors } from "oolib";



export const commonRowColActionMenuStyles = css`
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  ${transition("background-color", "border-color")};
  border-radius: 4px;
  ${({ active, theme }) =>
    active
      ? css`
          background-color: ${getPrimaryColor40(theme?.colors)};
          border: 1px solid;
          border-color: ${getPrimaryColor100(theme?.colors)};
        `
      : css`
          background-color: ${colors.white};
          border: 1px solid;
          border-color: ${colors.greyColor15};
          ${globalHoverOnWhiteBG};
        `}
  cursor: pointer;
  ${boxShadow1}
`;
